export default "__VITE_ASSET__DhVQydFW__"